<template>
  <div class="chart-error">
    <font-awesome-icon class="error-icon" icon="exclamation-circle"></font-awesome-icon>
    <div class="error-text">Failed to load chart data</div>
  </div>
</template>

<style scoped lang="scss">
@use '@/features/reports/components/reports.scss' as *;
</style>
